    const searchText = "Red Velvet Oil";
    const tooltipText = "Australia’s first upcycled skincare active";

    function addTooltipToText(root, searchText, tooltipText) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      const nodesToProcess = [];

      // Collect all matching text nodes first
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.nodeValue.includes(searchText)) {
          nodesToProcess.push(node);
        }
      }

      // Process each node after traversal to avoid TreeWalker issues
      nodesToProcess.forEach(node => {
        const parent = node.parentNode;
        const text = node.nodeValue;

        const parts = text.split(searchText);
        if (parts.length < 2) return;

        const fragment = document.createDocumentFragment();

        parts.forEach((part, index) => {
          fragment.appendChild(document.createTextNode(part));
          if (index < parts.length - 1) {
            const span = document.createElement("span");
            span.className = "tooltip-wrapper";
            span.setAttribute("data-tooltip", tooltipText);
            span.textContent = searchText;
            fragment.appendChild(span);
          }
        });

        parent.replaceChild(fragment, node);
      });
    }

    // Run the tooltip function on the entire body
    addTooltipToText(document.body, searchText, tooltipText);